// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import error_emitter from './utils/error-emitter';

error_emitter.install();

import Vue from 'vue';
import {sync} from 'vuex-router-sync';

import 'layer-src';

import router from './router';
import store from './store';

import './styles.scss';
import 'layer-src/src/theme/default/layer.css';

import vueWaves from './plugins/vue-waves';

Vue.use(vueWaves);

import Sticky from 'vue-sticky-directive/vue-sticky-directive'
Vue.use(Sticky);

/*
import ContextMenu from '@gahing/vcontextmenu'
import '@gahing/vcontextmenu/lib/vcontextmenu.css'
Vue.use(ContextMenu)*/

import * as filters from './filters';

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

import Layout from './components/layout/layout';

sync(store, router);

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== 'production') {
  Vue.config.devtools = true;
  Vue.config.performance = true
} else {
  Vue.config.errorHandler = function (err, vm, info) {
    error_emitter.report({
      source: 'vue',
      err,
      vm,
      info
    });
  };
}

new Vue({
  el: '#app',
  router,
  store,
  template: '<Layout/>',
  components: {Layout}
});



// WEBPACK FOOTER //
// ./src/main.js